module.exports = __webpack_public_path__ + "static/Tutoring-115a7eeaa6adadbb5695f38cb6fc534f.png";